/* TODO: Using Date-fns locale, need to reconsider if that's what we want:
 *  - DatePicker uses date-fns locale.
 *  - PhoneInput uses locale string to determine country
 *
 *  String property is nicer, but to let DatePicker actually be able to work
 *  with locales, it needs all (or all that we want to support) Locale objects
 *  in the runtime code to be able to pick the correct locale based on the string.
 *  Need to check size.
 *
 *  So: Preferably make locale?: string here
 * */
var _a;
import { __assign, __read } from "tslib";
import './overrides';
import React, { createContext, useContext, useMemo, } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { MuiThemeProvider, StylesProvider as MuiStylesProvider, } from '@material-ui/core';
import deepmerge from 'deepmerge';
import enUSLocale from 'date-fns/locale/en-US';
import invariant from 'invariant';
import { createMuiTheme } from '../../theme/mui-theme';
import { VelocityPrivateContextProvider } from '../VelocityPrivateContext/VelocityPrivateContext';
import { DefaultVelocityTheme } from '../../theme/VelocityTheme/DefaultVelocityTheme';
import { hyphenLocale } from '../../utils/strings/strings';
var DEFAULT_LOCALE_CODE = 'en-US';
var DEFAULT_DATE_FNS_LOCALES = (_a = {}, _a[DEFAULT_LOCALE_CODE] = enUSLocale, _a);
var context = createContext(undefined);
export var VelocityProvider = function (_a) {
    var children = _a.children, themeOverrides = _a.themeOverrides, materialUiExternalTheme = _a.materialUiExternalTheme, translateFn = _a.translateFn, _b = _a.dateFnsLocales, dateFnsLocales = _b === void 0 ? DEFAULT_DATE_FNS_LOCALES : _b, _c = _a.locale, locale = _c === void 0 ? DEFAULT_LOCALE_CODE : _c;
    locale = hyphenLocale(locale);
    var _d = useMemo(function () {
        var _a = getThemes(themeOverrides, materialUiExternalTheme), velocityTheme = _a.velocityTheme, muiTheme = _a.muiTheme;
        var scTheme = {
            velocity: velocityTheme,
        };
        return {
            velocityTheme: velocityTheme,
            scTheme: scTheme,
            muiTheme: muiTheme,
        };
    }, [themeOverrides, materialUiExternalTheme]), velocityTheme = _d.velocityTheme, scTheme = _d.scTheme, muiTheme = _d.muiTheme;
    var providerValue = useMemo(function () {
        var hyphenedDateFnsLocales = Object.entries(dateFnsLocales).reduce(function (acc, _a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            acc[hyphenLocale(key)] = val;
            return acc;
        }, {});
        var dateFnsLocale = getDateFnsLocale(locale, hyphenedDateFnsLocales);
        return {
            theme: velocityTheme,
            dateFnsLocale: dateFnsLocale,
            locale: locale,
        };
    }, [velocityTheme, locale, dateFnsLocales]);
    /*
    We use `MuiStylesProvider` here with `injectFirst={true}` to be able to overwrite MUI styles
    using `styled-components`. See more: https://material-ui.com/styles/advanced/#injectfirst
     */
    return (React.createElement(context.Provider, { value: providerValue },
        React.createElement(VelocityPrivateContextProvider, { translateFn: translateFn },
            React.createElement(MuiStylesProvider, { injectFirst: true },
                React.createElement(StyledComponentsThemeProvider, { theme: scTheme },
                    React.createElement(MuiThemeProvider, { theme: muiTheme }, children))))));
};
export var VelocityConsumer = context.Consumer;
export var useVelocityContext = function () {
    var ctx = useContext(context);
    invariant(ctx !== undefined, 'VelocityContext not found. Did you forget to put the VelocityProvider?');
    return ctx;
};
export var withVelocityContext = function (Component) {
    return function (props) {
        var ctx = useVelocityContext();
        return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement(Component, __assign({}, props, { velocityContext: ctx })));
    };
};
function getThemes(themeOverrides, materialUiExternalTheme) {
    var velocityTheme = themeOverrides
        ? deepmerge(DefaultVelocityTheme, themeOverrides)
        : DefaultVelocityTheme;
    var muiTheme = createMuiTheme(velocityTheme, materialUiExternalTheme);
    return {
        velocityTheme: velocityTheme,
        muiTheme: muiTheme,
    };
}
function getDateFnsLocale(locale, dateFnsLocales) {
    var dateFnsLocale = dateFnsLocales[locale];
    var retryLocaleCode = '';
    if (!dateFnsLocale && locale.length > 2) {
        // country part only
        retryLocaleCode = locale.slice(0, 2);
        dateFnsLocale = dateFnsLocales[retryLocaleCode];
    }
    if (!dateFnsLocale) {
        // eslint-disable-next-line no-console
        console.warn("No date-fns locale found for [" + locale + "]" + (retryLocaleCode ? ", nor [" + retryLocaleCode + "]" : '') + ", falling back to [" + DEFAULT_LOCALE_CODE + "] for date formatting.");
        dateFnsLocale = enUSLocale;
    }
    return dateFnsLocale;
}
//# sourceMappingURL=VelocityContext.js.map